import {useNuxtApp} from 'nuxt/app'
import {defineStore} from 'pinia'
import {ref} from 'vue'
import {useAuthStore} from '~/store/auth'
import {$lara} from '~/utils/$larafetch'

export const useStaticStore = defineStore('static', () => {
    const initialized = ref(false)
    const questionTypes = ref([])
    const poolQuestions = ref([])
    const countries = ref([])

    const authStore = useAuthStore()

    async function fetchStaticData() {
        const response = await $lara.get(useNuxtApp().$apiRoute('spa.static.index'))
        if (response.error) return
        initialized.value = true
        questionTypes.value = response.questionTypes ?? []
        poolQuestions.value = response.poolQuestions ?? []
        countries.value = response.countries ?? []
    }

    function check() {
        if (initialized.value) return
        if (!authStore.isAuthenticated) return
        fetchStaticData()
    }

    return {
        questionTypes,
        poolQuestions,
        countries,
        fetchStaticData,
        check
    }
})
